export enum ActivityScope {
	Dissertation = 'dissertation',
	FieldTrip = 'fieldTrip',
	Workshop = 'workshop',
	Course = 'course',
	Additional = 'additional',
}